module.exports = __webpack_public_path__ + "img/green-leaves-top.7acad25e.png";